module.exports = __webpack_public_path__ + "static/media/sparta_analytics.f3df2187.svg";